
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as CloudOffIconComponent } from "./cloud-off-icon.svg";

export const CloudOffIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <CloudOffIconComponent {...props} />;
};
